import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import Hideable from 'components/utils/Hideable';
import {BG} from 'constants/index';
import {navigate} from 'gatsby';
import {MobileProvider} from 'hooks/useIsMobile';
import {useRotate} from 'hooks/useRotate';

import * as styles from './styles.module.scss';

export interface InfoPanelRowProps {
	title?: string;
	bg?: BG;
	children: React.ReactNode[];
	actionBtnText?: string;
	actionBtnLink?: string;
}

const InfoPanelRow: FC<InfoPanelRowProps> = ({
	title,
	bg = BG.transparent,
	children,
	actionBtnText,
	actionBtnLink,
}) => {
	const mobile = useRotate(children);
	return (
		<div className={classNames({
			[styles.wrapper]: true,
			[styles.light]: bg === BG.light,
			[styles.dark]: bg === BG.dark,
		})} >
			<div className={styles.panel}>
				<Hideable show={!!title}>
					<h2>{title}</h2>
				</Hideable>
				<MobileProvider>
					<div className={classNames({
						[styles.items]: true,
						[styles.dark]: bg === BG.dark,
						[styles.mobile]: true,
					})}>
						{mobile}
					</div>
				</MobileProvider>
				<div className={classNames({
					[styles.items]: true,
					[styles.dark]: bg === BG.dark,
					[styles.desktop]: true,
				})}>
					{children}
				</div>
				{(actionBtnLink && actionBtnText) && (
					<Button
						variant='primary'
						onClick={() => navigate(actionBtnLink)}
						className={styles.button}>
						{actionBtnText}
					</Button>
				)}
			</div>
		</div>
	);
};
export default InfoPanelRow;
